import axios from 'axios';
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import { getRefreshToken } from '@api/auth';

export const ERR = {
  REQ_SUCCESS: 100, // 요청 성공
  REQ_PTSUCESS: 101, // 요청 부분 성공
  COMM_NOT_EXISTS_API: 151, // API URI가 존재하지 않음
  COMM_INVALID_REQUEST_PARAM: 152, // 필수 파라미터 누락, 요청 파라미터가 유효하지 않음
  COMM_INTERNAL_SERVER: 153, // 서버 오류
  COMM_DB_CONNECTION: 154, // DB 접속 오류
  COMM_RADIS_CONNECTION: 155, // REDIS 접속 오류
  COMM_AUTHORITY_TOKEN_EXPIRED: 156, // access token 만료
  COMM_REFRESH_TOKEN_EXPIRED: 157, // refresh token 만료
  COMM_PERMISSION_DENIED: 158, // 권한 없음
  COMM_NOTICE_NOT_EXISTS: 159, // 존재하지 않는 공지사항
  COMM_POLICY_NOT_EXISTS: 160, // 존재하지 않는 약관
  TOO_MANY_ACTIVE_CONTENTS: 162, // 콘텐츠가 제한개수보다 많음
  USER_NOT_EXIST_USER: 201, // 존재하지 않는 사용자
  USER_DUPLICATE_USER_MAIL: 202, // 사용자 메일 중복
  USER_NOT_APPROVED: 204, // 사용자 메일 인증되지 않음
  USER_NOT_EXISTS_FRANCHISE: 251, // 존재하지 않는 프랜차이즈
  USER_NOT_EXISTS_HASHTAG: 252, // 존재하지 않는 해시태그
  USER_DUPL_FRANCHISE: 253, // 중복된 프랜차이즈명
  USER_DUPL_HASHTAG: 254, // 중복된 해시태그명
  USER_NOT_EXISTS_FCGROUP: 255, // 존재하지 않는 프랜차이즈 그룹
  DEVICE_NOT_EXISTS: 301, // 존재하지 않는 장비
  DEVICE_NOT_EXISTS_GROUP: 302, // 존재하지 않는 장비 그룹
  CONTS_NOT_EXISTS_CATEGORY: 351, // 존재하지 않는 카테고리
  CONTS_NOT_EXISTS_THEME: 352, // 존재하지 않는 테마
  CONTS_NOT_EXISTS_ANIMATION: 353, // 존재하지 않는 애니메이션
  CONTS_NOT_EXISTS_CONTS_FILE: 354, // 존재하지 않는 콘텐츠 파일
  CONTS_FILE: 355, // 콘텐츠 파일 오류
  CONTS_FILE_SIZE: 356, // 콘텐츠 파일 크기 오류
  CONTS_FILE_FORM: 357, // 콘텐츠 형식 오류
  CONTS_TIME_EXCEED: 358, // 콘텐츠 재생시간 초과
  CONTS_ENCODING: 359, // 콘텐츠 인코딩 오류
  CONTS_ENCODING_SVR: 360, // 콘텐츠 인코딩 서버 오류
  SOURCE_VIDEO_FILE_WRITE_FAIL: 366, // 콘텐츠 인코딩 서버 오류
  PRODUCT_TYPE_ID_CANNOTBE_REGISTERED: 369, // 해당 Product Type을 사용하지 않음
  SCHEDULE_DUPL: 452, // 스케줄 중복
  SERVER_ERR: 500, // 서버 오류
  CONTS_NOT_EXISTS_THEME_ID: 504, // 테마 ID가 존재하지 않습니다
  REGION_CODE_NOT_FOUND: 505, // 지역 코드 오류
  CONTS_DURATION_TOO_SHORT: 506, // 사용자 영상 시간이 기준 시간보다 미만인경우 오류
  CONTS_EMPTY_FILE: 507, // 용량이 0인 파일인 경우 오류
};

export const API = {
  LOGIN: '/v1/auth/login/',
  TOKEN_REFRESH: '/v1/auth/refresh/',
  LOGOUT: '/v1/auth/logout/',
  FRANCHISE_SEARCH: '/v1/franchises/',
  FRANCHISE_SHOP: '/v1/franchises/shop/',
  FRANCHISE_SHOP_WAIT: '/v1/franchises/shop/wait/',
  CONTENTS: '/v2/contents/',
  CONTENTS_USER: '/v1/contents/user',
  FRANCHISE_CONTENTS: '/v1/contents/franchise/',
  FRANCHISE_CONTENTS_FIX: '/v2/contents/franchise/fix/',
  FRANCHISE_CONTENTS_USER: '/v1/contents/device/',
  FRANCHISE_CONTENTS_SEND: '/v1/contents/send/',
  FRANCHISE_CONTENTS_SEND_USER: '/v1/contents/send/user/',
  FRANCHISE_CONTENTS_SEND_GROUP: '/v1/contents/send/group/',
  FRANCHISE_CONTENTS_SEND_FCUSER: '/v1/contents/send/franchise-user/',
  FRANCHISE_GROUP: '/v1/franchises/group/',
  SERVICE: '/v1/services/',
  LOGO: '/v1/services/logo/',
  NOTICE: '/v1/notices/',
  FRANCHISE_SUMMARY: '/v1/franchises/summary/',
  USER_SUMMARY: '/v1/users/summary/',
  FRANCHISE_TAG: '/v1/franchises/hashtag/',
  SIGNUP: '/v2/auth/sign-up/franchise/',
  USER_SIGNUP: '/v2/auth/sign-up/user',
  POLICY: '/v1/policies/1G/',
  CHECKMAIL: '/v1/auth/check/email/',
  USER_DEVICE: '/v2/devices/',
  FRANCHISE_DEVICE: '/v1/devices/type/',
  FRANCHISE_DEVICE_DETAIL: '/v2/devices/',
  FRANCHISE_DEVICE_GROUP: '/v2/devices/group/',
  CHANGE_PW: '/v1/auth/change/password/',
  FIND_PW: '/v1/auth/find/password/',
  FIND_ID: '/v2/auth/find/email/',
  PROFILE: '/v2/users/',
  PROFILE_IMG: '/v2/users/image',
  SIGN_SETTING: '/v1/devices/setting/',
  SIGN_GROUP: '/v1/devices/group/',
  SIGN_POWER: '/v1/devices/setting/power/',
  SIGN_BRIGHTNESS: '/v1/devices/setting/brightness/',
  SIGN_SCHEDULE_POWER: '/v1/devices/setting/power/schedule/',
  SIGN_SCHEDULE_BRIGHTNESS: '/v1/devices/setting/brightness/schedule/',
  SIGN_PIN: '/v1/devices/pin/',
  THMENE_CATEGORY: '/v1/themes/category/',
  THEME: '/v1/themes/',
  THEME_CONVERT: '/v1/contents/convert/theme/',
  THEME_CONVERT_VIDEO: '/v1/contents/convert/video/',
  THEME_CONVERT_THEME: '/v1/contents/convert/upload/theme/',
  PLAYLIST: '/v2/playlists/',
  PLAYLIST_HQ: '/v2/playlists/franchise/',
  PLAYLIST_CONTENT: '/v2/playlists/content',
  PLAYLIST_CONTENTS_HQ: '/v2/playlists/franchise/content',
  SCHEDULE: '/v2/schedules/',
  SCHEDULE_HQ: '/v2/schedules/franchise/',
  API_THEME_CONVERT: '/v2/contents/convert/theme/',
  API_CONTENTS: '/v2/contents/',
  CONVERT_VIDEO: '/v2/contents/convert/video/',
  API_THEME_CONVERT_CAPTUREFILE: '/v2/contents/convert/capturefile/',
  API_THEME: '/v2/themes/',
  API_THEME_INFO: '/v1/themes/',
  CONVERT_CUSTOM_TEXT: '/v2/contents/convert/upload/custom_txt',
  CONVERT_CUSTOM: '/v2/contents/convert/upload/custom/',
  API_ENCODING_STATE: '/v2/encoding/',
  API_VIDEO_DOWNLOAD: 'v2/encoding/file/',
  API_APP_VIDEO_DOWNLOAD: 'v2/encoding/path/',
  API_THMENE_CATEGORY: '/v1/themes/category',
  API_THEME_CONVERT_THEME: '/v2/contents/convert/upload/theme/',
  API_IMAGE_CONVERT_IMAGE: '/v2/contents/convert/upload/image/',
  API_IMAGE_CONVERT_ONLY_IMAGE: '/v2/contents/convert/upload/only_image/',
  API_IMAGE_CONVERT_MULTI_IMAGE: '/v2/contents/convert/upload/multi_image/',
  API_IMAGE_CONVERT_MULTI_ONLY_IMAGE:
    '/v2/contents/convert/upload/multi_only_image/',

  HTTP_METHOD_GET: 'GET', // HTTP GET
  HTTP_METHOD_POST: 'POST', // HTTP POST

  STATUS_SUCCESS: 200,
  ERR_REQ_SUCCESS: 100, // 요청 성공
  ERR_REQ_PTSUCESS: 101, // 요청 부분 성공

  API_WEATHER: '/v2/playlists/weather',
  API_FINEDUST: '/v2/playlists/finedust',
  API_ULTRAFINEDUST: '/v2/playlists/ultrafinedust',
  API_CLOCKS: '/v2/playlists/clocks',
  API_NEWS: '/v2/playlists/news',

  QUY_ACCU_APIKEY: 'qln1sJoAgL0IuoesxAHsoyFEeGGBBWKX',
  API_ACCU_LOCATION: '//dataservice.accuweather.com/locations/v1/search',
  API_ACCU_WEATHER: '',
};

export const LANG = {
  ko: 'ko-kr',
  ja: 'ja-jp',
  en: 'en-us',
};

const nodeEnv = process.env.NODE_ENV;
axios.defaults.baseURL =
  nodeEnv === 'production'
    ? process.env.REST_API_URI
    : 'http://192.168.0.200:58000/';

let tokenRequestLimiterEnabled = false;

function handleRefreshTokenExpire() {
  if (
    sessionStorage.getItem('refreshToken') &&
    confirm(String(eve.Lang.t('common.t_msg_req_login_again')))
  ) {
    sessionStorage.clear();
    window.location.href = '/auth/login';
  }
}

async function handleAccessTokenExpire() {
  try {
    const { data } = await getRefreshToken({
      refresh_token: sessionStorage.getItem('refreshToken'),
      grant_type: 'refresh_token',
    });
    sessionStorage.accessToken = `Bearer${data.items.accessToken}`;
    sessionStorage.refreshToken = data.items.refreshToken;
    sessionStorage.user_info = JSON.stringify(data.items);
    sessionStorage.role_code = data.items.user.role_code;
    sessionStorage.setItem('access_type', 'web');

    if (data.code === Common.CODE_OK) {
      window.location.reload();
    }
  } catch (err) {
    handleRefreshTokenExpire();
  }
}

function requestRefreshToken(handle) {
  if (tokenRequestLimiterEnabled === false) {
    tokenRequestLimiterEnabled = true;
    setTimeout(() => {
      tokenRequestLimiterEnabled = false;
    }, 1000);
    handle();
  }
}

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const errCode = error.response.data.code;
    const roleCode = sessionStorage.getItem('role_code');
    const baseURL = window.location.href;

    switch (errCode) {
      case ERR.COMM_NOT_EXISTS_API:
      case ERR.COMM_INVALID_REQUEST_PARAM:
        alert(eve.Lang.t('common.t_error'));
        eve.goPage(baseURL);
        break;
      case ERR.COMM_INTERNAL_SERVER:
        alert(eve.Lang.t('user.server_error'));
        break;
      case ERR.COMM_NOTICE_NOT_EXISTS:
      case ERR.COMM_POLICY_NOT_EXISTS:
        alert(eve.Lang.t('common.t_not_exists_posts'));
        eve.goPage(baseURL);
        break;
      case ERR.COMM_REFRESH_TOKEN_EXPIRED:
      case 400:
        requestRefreshToken(handleRefreshTokenExpire);
        break;
      case ERR.COMM_PERMISSION_DENIED:
        alert(eve.Lang.t('common.t_msg_insert_memberinfo'));
        break;
      case ERR.USER_NOT_EXIST_USER:
        alert(eve.Lang.t('common.t_err_not_exist_user'));
        window.location.reload();
        break;
      case ERR.USER_DUPLICATE_USER_MAIL:
        alert(eve.Lang.t('common.t_exist_id'));
        window.location.reload();
        break;
      case ERR.USER_NOT_APPROVED:
        // 권한 별로 띄우는 메세지를 다르게 하기 위함
        if (roleCode !== '12003') {
          alert(eve.Lang.t('common.t_msg_confirm_email'));
        } else {
          alert(eve.Lang.t('common.d_not_fran'));
        }
        break;
      case ERR.USER_NOT_EXISTS_FRANCHISE:
        alert(eve.Lang.t('common.t_msg_no_such_franchise'));
        break;
      case ERR.USER_NOT_EXISTS_HASHTAG:
        alert(eve.Lang.t('common.t_msg_not_exist_tag'));
        break;
      case ERR.USER_DUPL_FRANCHISE:
        alert(eve.Lang.t('common.t_err_dupl_franchise_name'));
        break;
      case ERR.DEVICE_NOT_EXISTS:
      case ERR.DEVICE_NOT_EXISTS_GROUP:
        alert(eve.Lang.t('common.t_err_not_exist_device'));
        break;
      case ERR.CONTS_NOT_EXISTS_CATEGORY:
        alert(eve.Lang.t('common.t_err_not_exist_category'));
        break;
      case ERR.CONTS_NOT_EXISTS_THEME:
        alert(eve.Lang.t('common.t_err_not_exist_category'));
        break;
      case ERR.CONTS_NOT_EXISTS_ANIMATION:
        alert(eve.Lang.t('common.t_err_not_exist_animation'));
        break;
      case ERR.CONTS_NOT_EXISTS_CONTS_FILE:
        alert(eve.Lang.t('common.t_msg_no_such_mov'));
        break;
      case ERR.CONTS_FILE:
        // alert(eve.Lang.t('common.d_file_mov_error'));
        break;
      case ERR.CONTS_FILE_SIZE:
        alert(eve.Lang.t('common.d_size_mov_error'));
        break;
      case ERR.CONTS_FILE_FORM:
        alert(eve.Lang.t('common.d_format_error'));
        break;
      case ERR.CONTS_TIME_EXCEED:
        alert(eve.Lang.t('common.d_time_over_error'));
        break;
      case ERR.TOO_MANY_ACTIVE_CONTENTS:
        alert(eve.Lang.t('play_list.too_many_contents'));
        break;
      case ERR.CONTS_ENCODING:
        // alert(eve.Lang.t('common.d_encoding_error'));
        break;
      case ERR.CONTS_ENCODING_SVR:
        // alert(eve.Lang.t('common.d_encoding_server_error'));
        break;
      case ERR.SOURCE_VIDEO_FILE_WRITE_FAIL:
        break;
      case ERR.PRODUCT_TYPE_ID_CANNOTBE_REGISTERED:
        break;
      case ERR.CONTS_NOT_EXISTS_THEME_ID:
        alert(eve.Lang.t('common.t_err_not_exist_theme_id'));
        break;
      case ERR.REGION_CODE_NOT_FOUND:
        break;
      case ERR.COMM_AUTHORITY_TOKEN_EXPIRED:
      case 401:
        requestRefreshToken(handleAccessTokenExpire);
        break;
      default:
        // alert(eve.Lang.t('user.server_error'));
        break;
    }
    return Promise.reject(error);
  },
);

export default { API, LANG };
